export default class ProductDataSource {
	type: string;

	suklReference: boolean;

	constructor(type: string, suklReference: boolean) {
		this.type = type;
		this.suklReference = suklReference;
	}
}
